import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSubscribeIconYp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={47} height={40} fill="none" {...props}>
    <path fill="#fec6cc" d="M2.667 5.867h41.6v32h-41.6z" />
    <path
      fill="#F32A52"
      d="M19.656 24.759a6.667 6.667 0 1 0-9.312 0 8.33 8.33 0 0 0-3.677 6.908 1.666 1.666 0 1 0 3.333 0c0-2.76 2.24-5 5-5s5 2.24 5 5a1.666 1.666 0 1 0 3.334 0 8.33 8.33 0 0 0-3.677-6.909ZM11.667 20a3.332 3.332 0 0 1 5.69-2.356A3.332 3.332 0 1 1 11.667 20ZM38.334 16.667h-10a1.666 1.666 0 1 0 0 3.333h10a1.666 1.666 0 1 0 0-3.333ZM38.334 23.333h-10a1.666 1.666 0 1 0 0 3.334h10a1.666 1.666 0 1 0 0-3.334ZM38.334 30h-10a1.666 1.666 0 1 0 0 3.334h10a1.666 1.666 0 1 0 0-3.334Z"
    />
    <path
      fill="#F32A52"
      d="M41.667 3.333h-8.64A4.993 4.993 0 0 0 28.335 0h-10a4.993 4.993 0 0 0-4.694 3.333H5a5.088 5.088 0 0 0-5 5.16V35a5.004 5.004 0 0 0 5 5h36.667a5.004 5.004 0 0 0 5-5V8.494a5.088 5.088 0 0 0-5-5.16Zm-23.333 0h10a1.666 1.666 0 1 1 0 3.334h-10a1.666 1.666 0 1 1 0-3.334Zm25 31.667c0 .92-.746 1.667-1.667 1.667H5c-.92 0-1.666-.746-1.666-1.667V8.494A1.753 1.753 0 0 1 5 6.667h8.64A4.993 4.993 0 0 0 18.334 10h10a4.993 4.993 0 0 0 4.693-3.333h8.64a1.753 1.753 0 0 1 1.666 1.827V35Z"
    />
    <path fill="#F32A52" d="M16 3.2h15.467V8H16z" />
  </svg>
);
export default SvgSubscribeIconYp;
